import clipVersions from './tutor-media-versions.json' with { type: 'json' };
import fileSizes from './tutor-media-sizes.json' with { type: 'json' };
/** Shared cache keys; generated with the learner-served media, never per app. */
export const tutorMediaVersions = clipVersions;
export function coachRosterPortraitPath(contentKey) {
    return `/cb/coaches/coach-${encodeURIComponent(contentKey)}-roster.jpg`;
}
export function coachSessionCoverPath(contentKey) {
    return `/cb/coaches/coach-${encodeURIComponent(contentKey)}-session-cover.webp`;
}
export function idleLoopClip(contentKey, versions = tutorMediaVersions) {
    const version = versions[`${contentKey}/idle`];
    return version ? `/cb/coaches/idle-${encodeURIComponent(contentKey)}.mp4?v=${encodeURIComponent(version)}` : null;
}
export function introVideoClip(contentKey, versions = tutorMediaVersions) {
    const version = versions[`${contentKey}/video`];
    return version ? `/cb/coaches/intro-${encodeURIComponent(contentKey)}-video.mp4?v=${encodeURIComponent(version)}` : null;
}
/** Relative URLs are hosted by Student; each consumer supplies its runtime web origin. */
export function tutorMediaFor(contentKey) {
    const valid = /^[a-z0-9]+(?:-[a-z0-9]+)*$/.test(contentKey);
    return {
        portrait: valid ? coachRosterPortraitPath(contentKey) : null,
        still: valid ? coachSessionCoverPath(contentKey) : null,
        listening: valid ? idleLoopClip(contentKey) : null,
        speaking: valid ? introVideoClip(contentKey) : null,
    };
}
/** Exact committed file bytes, independent of transfer compression or partial video requests. */
export function tutorMediaByteSize(path) {
    return path ? fileSizes[path.split('?')[0]] : undefined;
}
//# sourceMappingURL=tutor-media-catalog.js.map